/** Text entry owns the keyboard; ordinary buttons and panels never own movement. */
export function isGameplayKeyboardField(target: Element | null): boolean {
  if (!(target instanceof HTMLElement) || target.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
  const control = target as HTMLInputElement;
  if (control.disabled || control.readOnly) return false;
  if (target.isContentEditable || target.closest('[contenteditable="true"]')) return true;
  const tag = target.tagName.toLowerCase();
  if (tag === 'textarea' || tag === 'select') return true;
  return tag === 'input' && !['button', 'submit', 'reset', 'checkbox', 'radio', 'range', 'color', 'file', 'hidden'].includes(control.type.toLowerCase());
}
